
import Image from "next/image";
import React from "react";
export default function ExperienceSelector({
  setIsExperienceSelected,
  setExperienceLevel,
  handleAnalyseResume
}: {
  setIsExperienceSelected: React.Dispatch<React.SetStateAction<boolean>>;
  setExperienceLevel: React.Dispatch<
    React.SetStateAction<"FRESHER" | "EXPERIENCED" | null>>;
  handleAnalyseResume: () => void;
}) {
  return (
    <div className="flex flex-col gap-10 items-center justify-center min-h-screen relative">
      <div className="lg:absolute hidden lg:block text-center lg:top-40 lg:left-1/2 transform -translate-x-1/2 text-3xl font-bold">
        I am
      </div>
      <span className="lg:hidden text-center text-3xl font-bold">
        I am
      </span>
      <div className="flex flex-col lg:flex-row lg:space-y-0 space-y-10 lg:space-x-20">
        <div className="bg-white group hover:bg-[#9794F8] relative rounded-[60px] size-[350px] lg:p-6 shadow-md w-60 h-60 lg:w-96 lg:h-96 flex flex-col cursor-pointer items-center justify-center" onClick={() => {
          setExperienceLevel("FRESHER");
          setIsExperienceSelected(true);
          handleAnalyseResume();
        }}>
          <Image
            src="/assets/fresher.png"
            loading="eager"
            alt="Fresher"
            
            width={300}
            height={300}
            className="w-full lg:w-full"
          />
          <span className=" text-[25px] lg:text-[42px] group-hover:scale-125 transition-all duration-500 absolute bottom-0 left-[-50px] font-semibold ">FRESHER</span>
        </div>
        <div className="bg-white group hover:bg-[#9794F8] relative rounded-[68px] size-[350px] lg:p-6 shadow-md w-60 h-60 lg:w-96 lg:h-96 flex flex-col items-center cursor-pointer justify-center" onClick={() => {
          setExperienceLevel("EXPERIENCED")
          setIsExperienceSelected(true)
          handleAnalyseResume();
        }}>
          <Image
            src="/assets/experienced.png"
            loading="eager"
            alt="Experienced"
            width={300}
            height={300}
            className="w-full lg:w-full"
          />
          <span className="text-[25px] lg:text-[42px] group-hover:scale-125 transition-all duration-500 absolute top-5 right-[-40px] lg:right-[-150px] font-semibold">EXPERIENCED</span>
        </div>
      </div>
    </div>
  );
}
